import { render, staticRenderFns } from "./luolan.vue?vue&type=template&id=04196b36&scoped=true&"
import script from "./luolan.vue?vue&type=script&lang=js&"
export * from "./luolan.vue?vue&type=script&lang=js&"
import style0 from "./luolan.vue?vue&type=style&index=0&id=04196b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04196b36",
  null
  
)

export default component.exports